import ApiShadow, { ShadowType, SHADOW_TYPES } from "../api/model/snapshots/layers/Shadow";
import { VariableReference } from "../api/model/variables/Variables";
import { PartialOnly } from "../utils/UtilityTypes";

import Color from "./color";
import ColorDefinition from "./ColorDefinition";
import Model from "./model";

export default class Shadow extends Model {
    #type: ShadowType;
    offsetX: number;
    offsetY: number;
    blurRadius: number;
    spread: number;
    #color: Color;
    #variableReferences: VariableReference[] | undefined;

    constructor({
        type,
        offsetX,
        offsetY,
        blurRadius,
        spread,
        color,
        variableReferences
    }: ApiShadow) {
        super();

        this.#type = type;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        this.blurRadius = blurRadius;
        this.spread = spread;
        this.#color = new Color(color);
        this.#variableReferences = variableReferences;
    }

    get type(): ShadowType {
        return this.#type;
    }

    set type(type: ShadowType) {
        if (SHADOW_TYPES.indexOf(type) === -1) {
            throw new TypeError(`Unknown shadow type: '${type}'. Possible values: ${JSON.stringify(SHADOW_TYPES)}`);
        }

        this.#type = type;
    }

    get color(): Color {
        return this.#color;
    }

    set color(value: PartialOnly<ColorDefinition, "a">) {
        this.#color = new Color(value);
    }

    get variableReferences() : VariableReference[] | undefined {
        return this.#variableReferences;
    }

    set variableReferences(variableReferences: VariableReference[] | undefined) {
        this.#variableReferences = variableReferences;
    }

    override toObject(): ApiShadow {
        return {
            type: this.type,
            offsetX: this.offsetX,
            offsetY: this.offsetY,
            blurRadius: this.blurRadius,
            spread: this.spread,
            color: this.color.toObject(),
            variableReferences: this.variableReferences
        };
    }
}
